import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import WapiService from 'wanderu-service-wapi';
import { makeQueryString } from 'wanderu-utils';

import {
    actions as carrierActions,
} from '../../appstate';
import {
    FILTER_FIELDS,
    MIX_TRIP_CARRIER_CODE,
} from '../../constants';
import {
    fetchAllCarriersAction,
} from '../fetchAllCarriers';
import {
    namespace,
    actions,
    reducer,
    selectors,
} from './base';

const logger = Logger.getLogger('wanderu-ducks-carriers');

function fetchCarrier(carrierCode) {
    return async (dispatch, getState) => {
        let error;

        if (carrierCode === MIX_TRIP_CARRIER_CODE) {
            return;
        }

        const allCarriersFetching = fetchAllCarriersAction.selectWorking(getState());
        const allCarriersHasFetched = fetchAllCarriersAction.selectSuccess(getState());
        if (allCarriersFetching || allCarriersHasFetched) {
            return;
        }

        const hasFetched = selectors.selectSuccess(getState(), carrierCode);
        const isFetching = selectors.selectWorking(getState(), carrierCode);
        if (hasFetched || isFetching) {
            return;
        }

        dispatch(actions.startWork(carrierCode));

        try {
            const query = {
                fields: FILTER_FIELDS.join(','),
            };

            const carrierData = await WapiService.get(`carriers.json/${carrierCode}${makeQueryString(query)}`);

            if (!carrierData) {
                throw new Error('no carrier data found');
            }

            return dispatch(carrierActions.setCarrierData(carrierCode, carrierData.result));
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.warn('fetchCarrier', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = {
                message: ex.message,
            };
        } finally {
            dispatch(actions.endWork(carrierCode, undefined, error));
        }
    };
}

function setSuccess(carrierCode, meta) {
    return actions.endWork(carrierCode, meta);
}

const fetchCarrierAction = {
    fetchCarrier,
    setSuccess,
    ...selectors,
};

export {
    fetchCarrierAction,
};

export default {
    [namespace]: reducer,
};
